import React, { useState } from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BasicSelect from "./BasicSelect";
import { useSelector } from "react-redux";
import { selectCatagory } from "../utils/menuItems";
import LeadAdForm from "./Lead/LeadAdForm";
import MeetingAdForm from "./Meeting/MeetingAdForm";
import BookingAdForm from "./Booking/BookingAdForm";
import { useHierarchyUsersDataQuery } from "../store/services/user";
import { useLocation } from "react-router-dom";


const AdvanceSearch = ({ handleClose, title }) => {
const { type } = useSelector((state) => state.query);
const location = useLocation();

const getCategoryFromPath = () => {
  const path = location.pathname;

  if (path.includes("callingData")) return "calling_data";
  if (path.includes("meetings")) return "meeting";
  if (path.includes("bookings")) return "booking";
  return "lead";
};

const [catagory, setCatagory] = useState(
  type || getCategoryFromPath()
);
  const handleCatagory = (e) => {
    const selectedCategory = e.target.value;
    setCatagory(selectedCategory);
  };

  const { data = {} } = useHierarchyUsersDataQuery();
  // console.log("hierarchy users", data)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexShrink: 0,
          pb: 2,
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { sm: "1rem", md: "1.5rem" },
              color: "#000000",
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
          <Divider
            sx={{
              backgroundColor: "#2c67c6",
              width: "100%",
              margin: "0 auto",
            }}
          />
        </Box>
        <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          mt: 3,
        }}
      >
        <Grid container columnSpacing={4} sx={{ flexShrink: 0 }}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: 18,
                mb: 1,
                fontWeight: 500,
                color: "#000000",
              }}
            >
              Catagory
            </Typography>
            <BasicSelect
              name={"catagory"}
              value={catagory}
              size="small"
              handleChange={handleCatagory}
              items={selectCatagory}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            mt: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {catagory === "lead" || catagory === "calling_data" ? (
            <LeadAdForm handleClose={handleClose} users={data} leadCatagory={catagory} />
          ) : catagory === "meeting" ? (
            <MeetingAdForm handleClose={handleClose} users={data} />
          ) : catagory === "booking" ? (
            <BookingAdForm handleClose={handleClose} users={data} />
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default AdvanceSearch;
